import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../../services/system/storage.service';
import { ListingCategory } from '../../../../models/inModels/MarketPlaceModel';
import { ListingCategoryService } from '../../../../services/listing-categories/listing-category.service';

@Component({
  selector: 'app-edit-listing-category',
  templateUrl: './edit-listing-category.component.html',
})
export class EditListingCategoryComponent implements OnInit {
  model: ListingCategory;
  loading = false;
  error: Message[];
  messages: Message[];
  id: number;
  constructor(
    public storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ListingCategoryService) {
    this.model = new ListingCategory();
  }

  ngOnInit() {
    this.loading = true;
    this.id = this.route.snapshot.params.Id;
    this.service.getCategory(this.id).then(
      res => {
        this.model = new ListingCategory(res);
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.messages = [];
        this.messages.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  goBack(): void {
    this.router.navigate(['/marketplace/listing-category/group/edit', this.model.GroupId]);
  }

  save() {
    this.loading = true;
    this.service.updateCategory(this.model).then(
      res => {
        this.model = new ListingCategory(res);
        this.loading = false;
        this.goBack();
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  handleDisplayImage(event): void {
    var result = this.storageService.handleSuccess(event);
    this.model.ImageId = result.PublicId;
    this.loading = false;
  }
    
  handleError(event): void {
    this.loading = false;
    this.error = [];
    this.storageService.handleError(event, this.error);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/listing-categories/edit/edit-category/edit-listing-category.component.ts